<template>
  <div class="toolbar" :class="{ 'toolbar--hide': hide }">
    <button
      type="button"
      class="button"
      :data-pixel="pixels.task"
      @click="showTask"
    >
      Задание
    </button>
    <button
      type="button"
      class="button button--white"
      :data-pixel="pixels.rules"
      @click="showRules"
    >
      Как играть
    </button>
  </div>
</template>

<script>
export default {
  props: ["hide"],
  data() {
    return {
      pixels: {
        task:
          "https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=dnchq&pfb=jhizr&pr=%random%&ptrc=b",
        rules:
          "https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=dnchq&pfb=jhizs&pr=%random%&ptrc=b"
      }
    };
  },
  methods: {
    showRules() {
      this.$store.commit("toggleModal", "howToPlay");
    },
    showTask() {
      this.$store.commit("toggleModal", "currentTask");
    }
  }
};
</script>

<style lang="scss" scoped>
.toolbar {
  position: absolute;
  z-index: 50;

  left: 0;
  top: 15%;
  transition: all 0.55s ease;

  display: grid;
  row-gap: 10px;

  .button {
    min-width: 137px;
    grid-template-columns: auto 1fr;
    transform: translateX(-20px);
    transition: transform 0.25s ease;

    &:hover {
      transform: translateX(-5px);
    }

    &::before {
      content: "";
      width: 20px;
    }
  }

  &--hide {
    transform: translateX(-137px);
  }
}
</style>
